import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Comment } from 'src/app/models/comment.model';
import { ApiMethod } from 'src/app/decorators/api-method.decorator';

@Injectable({
	providedIn: 'root'
})
export class FollowUpService {

	private baseFollowUpUrl = `${environment.baseUrl}/followup`;

	constructor(private httpClient: HttpClient) { }

	@ApiMethod()
	getJobFollowUp(token: string): Observable<Comment> {
		return this.httpClient.get<Comment>(`${this.baseFollowUpUrl}/${token}`);
	}

	@ApiMethod()
	updateJobFollowUp(token: string, comment: Comment): Observable<void> {
		return this.httpClient.patch<void>(`${this.baseFollowUpUrl}/${token}`, comment);
	}

	@ApiMethod()
	completeJobFollowUp(token: string): Observable<void> {
		return this.httpClient.patch<void>(`${this.baseFollowUpUrl}/${token}/complete`, {});
	}
}
